import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clientbriefbob() {
  return (
    <section
      className="client_brief_bob p-100 text_white"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              A Smarter Way of Creating Countless Possibilities for Your
              Business
            </h2>
          </Col>
        </Row>
        <Row className="pt-60">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/bob/client_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={444}
                height={750}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>Client’s Brief</h2>
            <p>
              The B.O.B app was aimed at welcoming a new growth opportunity and
              business opportunities for businesses. The app was to be designed
              in such a way that it would offer businesses a seamless, quick,
              growth-driven, and efficient way of listing their business within
              the market.
            </p>
            <p>
              This listing would enable the business to accomplish growth and
              revenue-related feats. The users would be able to quickly list
              their business on the internet-based business directory that the
              app offered. Moreover, there were other features that the mobile
              application had to offer, some of which were; review and rating
              details, business descriptions, search filters, push
              notifications, and more.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientbriefbob;
